import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppServiceService } from 'src/app/app-service.service';
import { RoleModuleMappingService } from 'src/app/authmanager/RoleModuleMapping';
import { RoleModuleAccess } from 'src/app/product-config-admin/product-config';
import { ProductConfigAdminService } from 'src/app/product-config-admin/product-config-admin.service';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';
import { include } from 'underscore';


@Injectable({
  providedIn: 'root'
})
export class ChildGuardGuard {
  userDetails: any;
  lstchildRoute: any;
  lstResult: boolean = false;
  selectedCustomer: Customer;
  selectedUnit: Unit;
  lstUserRolesArr: any[] = [];
  constructor(
    private appService: AppServiceService,
    private router: Router,
    private productConfigAdminService: ProductConfigAdminService
  ) {
    this.appService.userDetails.subscribe(d => this.userDetails = d);
    this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
    // this.getRoleModule();


  }
  // ngOnInit(): void {
  //   this.getRoleModule();
  // }
  //  async getRoleModule() {
  //     this.lstUserRolesArr = [];
  //     this.productConfigAdminService.getRoleModuleMapping(this.selectedCustomer.customerId).subscribe(async (data: RoleModuleAccess[]) => {
  //       if (data?.length > 0) {
  //         this.lstUserRolesArr = await data;

  //       }
  //     });

  //   }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const promise = await this.productConfigAdminService.getRoleModuleMapping(this.selectedCustomer.customerId).toPromise();
    this.lstUserRolesArr = promise;
    let modueData: any[] = childRoute.data.module;
    let lstModuleName = this.lstUserRolesArr.find(role => role.roleName == this.userDetails.roles[0].roleName);
    if (modueData != undefined || modueData != null) {
      let lstMatchedModule = lstModuleName.associatedModules.some(s => s.moduleName == modueData && s.accessLevels.includes("View"));
      if (lstMatchedModule) {
        return this.lstResult = true;
      }
      else {
        this.router.navigate(["../../access-denied"]);
        return this.lstResult = false;
      }

    }
    return null
  }




}
